import Link from 'next/link';
import React, { memo } from 'react';
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';
import useWindowWidth from '../../../hooks/useWindowWidth';
import styles from '../../../styles/components/section/top/Kv.module.scss';
import Img from '../../section/common/Img';

const SwiperTopKvBanner = memo(({ banners, siteDomein }) => {
    const { breakPoint, windowWidth } = useWindowWidth();

    if (windowWidth > breakPoint && banners.items.length >= 4) {
        return (
            <Swiper
                className={styles.bannerList}
                slidesPerView="auto"
                centeredSlides={false}
                loop={true}
                speed={1200}
                autoplay={{
                    delay: 4100,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    768: {},
                }}
            >
                {banners.items.map((banner) => {
                    return (
                        <SwiperSlide
                            className={styles.bannerItem}
                            key={banner.sys.id}
                        >
                            {banner.fields.url.charAt(0) === '/' ? (
                                <Link href={banner.fields.url} className={`${styles.bannerLink}`}>

                                    <div className={styles.bannerImg}>
                                        <Img
                                            hover={false}
                                            src={
                                                `https:` +
                                                banner.fields.image.fields
                                                    .file.url +
                                                `?fm=webp&q=35`
                                            }
                                            alt={banner.fields.alt}
                                        />
                                    </div>

                                </Link>
                            ) : (
                                <a
                                    href={banner.fields.url}
                                    className={`${styles.bannerLink}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <div className={styles.bannerImg}>
                                        <Img
                                            hover={false}
                                            src={
                                                `https:` +
                                                banner.fields.image.fields.file
                                                    .url +
                                                `?fm=webp&q=35`
                                            }
                                            alt={banner.fields.alt}
                                        />
                                    </div>
                                </a>
                            )}
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        );
    } else {
        return (
            <ul className={styles.bannerList}>
                {banners.items.map((banner) => {
                    return (
                        <li
                            className={styles.bannerItem}
                            key={banner.fields.url}
                        >
                            {banner.fields.url.charAt(0) === '/' ? (
                                <Link href={banner.fields.url} className={`${styles.bannerLink}`}>

                                    <img
                                        className={styles.bannerImgInside}
                                        src={
                                            `https:` +
                                            banner.fields.image.fields.file
                                                .url +
                                            `?fm=webp&q=35`
                                        }
                                        alt={banner.fields.alt}
                                    />

                                </Link>
                            ) : (
                                <a
                                    href={banner.fields.url}
                                    className={`${styles.bannerLink}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        className={styles.bannerImgInside}
                                        src={
                                            `https:` +
                                            banner.fields.image.fields.file
                                                .url +
                                            `?fm=webp&q=35`
                                        }
                                        alt={banner.fields.alt}
                                    />
                                </a>
                            )}
                        </li>
                    );
                })}
            </ul>
        );
    }
});

SwiperTopKvBanner.displayName = 'SwiperTopKvBanner';

export default SwiperTopKvBanner;
